module.exports = __webpack_public_path__ + "static/media/findus2.6f9c8a7b.png";